import { ClientId } from "../utils/config";

class ViewSDKClient {
  constructor() {
    this.readyPromise = new Promise((resolve) => {
      if (window.AdobeDC) {
        resolve();
      } else {
        document.addEventListener("adobe_dc_view_sdk.ready", () => {
          resolve();
        });
      }
    });
    this.adobeDCView = undefined;
  }
  ready() {
    return this.readyPromise;
  }
  async previewFile(divId, viewerConfig, url) {
    const config = {
      // slifratech.in
      // clientId: "7c3bfef193984fbb87dfc1befa3e9600",
      // local host
      // clientId: "db80966dd5b149ddb3680ffd39e2fbef",
      // camptratech
      clientId: "c75338eb95874316af6b5a7df0856092",
      // jira kr
    //   clientId: "4a7a51c9f76646bd9b143651bdf00cd8",
    // serviceNow
        // clientId: "dcc6c6889c034a60b3c7f981403e8436",
      // link-kr
      // clientId: "8e6258018f374451b059bae39d253fdc",
      // maclister
      // clientId: "1a361809435649a29436d9606c931aa1",
      // clientId: { ClientId },
      // krStageing
      // clientId: "574682abf67a4f2ca83e2f26b5d36f55",
      // lhc
      // clientId: "3a03e298959f4a24aff6fc0b4f43cee5",
    };
    if (divId) {
      config.divId = divId;
    }
    this.adobeDCView = new window.AdobeDC.View(config);
    console.log("line26=", url);
    // let blob = await fetch(url).then((r) => r.blob());
    // console.log("blob=`", blob);

    let filename = url.split("/");
    const previewFilePromise = this.adobeDCView.previewFile(
      {
        content: {
          location: {
            url: url,
            // promise: blob,
            // url: "https://kr.camptratech.com/kr/wp-content/uploads/2023/12/Ablation-in-the-US-Practice-Pearl_FINAL_compressed-1-9.pdf",
          },
        },
        metaData: {
          fileName: filename[filename.length - 1],
          id: "6d07d124-ac85-43b3-a867-36930f502ac6",
        },
      },
      viewerConfig
    );
    this.registerEventsHandler();
    return previewFilePromise;
  }
  // previewFileUsingFilePromise(divId, filePromise, fileName) {
  //   this.adobeDCView = new window.AdobeDC.View({
  //     // slifratech.in
  //     // clientId: "7c3bfef193984fbb87dfc1befa3e9600",
  //     // local host
  //     clientId: "db80966dd5b149ddb3680ffd39e2fbef",
  //     // camptratech
  //     // clientId: "c75338eb95874316af6b5a7df0856092",
  //     divId,
  //   });
  //   this.adobeDCView.previewFile(
  //     {
  //       content: {
  //         promise: filePromise,
  //       },
  //       metaData: {
  //         fileName: fileName,
  //       },
  //     },
  //     {}
  //   );
  // }
  registerEventsHandler() {
    this.adobeDCView.registerCallback(
      window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
      (event) => {
        console.log("PrintOption:" + event?.data?.printSupported);
        console.log(event);

        console.log("Event is called");
        if (event.type === "DOCUMENT_PRINT") {
          // return true;
          console.log("Print is called");
          // Reload
          window.location.replace("/knowledgerepo");

          //  event.preventDefault();
          //event.stopPropagation();
        }
        console.log(event);
      },
      {
        enablePDFAnalytics: true,
      }
    );
    this.adobeDCView.previewFile();
  }
}
export default ViewSDKClient;
